import { useEffect } from 'react'

// 弹层打开期间锁住页面滚动：不锁的话滚轮会穿透蒙层滚动背景页。
// 计数是因为可以叠开（弹窗里再开灯箱），只有最外层那个负责恢复。
let openLayers = 0
let restoreOverflow = ''
let restorePadding = ''

export function useScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return
    const { body, documentElement } = document
    if (openLayers === 0) {
      restoreOverflow = body.style.overflow
      restorePadding = body.style.paddingRight
      // 补上滚动条腾出的宽度，否则锁滚动的一瞬间整页会横向跳一下
      const gutter = window.innerWidth - documentElement.clientWidth
      body.style.overflow = 'hidden'
      if (gutter > 0) body.style.paddingRight = `${gutter}px`
    }
    openLayers += 1
    return () => {
      openLayers -= 1
      if (openLayers === 0) {
        body.style.overflow = restoreOverflow
        body.style.paddingRight = restorePadding
      }
    }
  }, [active])
}
